import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import { createPinia } from 'pinia'
import dayjs from 'dayjs'
dayjs.locale('zh-cn')

import './style/index.less'
import mtkf from './mtkf'
import i18n from './locales'
import router from './router'
import App from './App.vue'
import './tailwind.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(Antd)
app.use(i18n)
app.use(mtkf)

// 挂载app
app.mount('#app')
